import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

/**
 * Der Rahmen eines Screens.
 *
 * Feste Displayhöhe statt Dokumentfluss - gescrollt wird nur innerhalb des
 * Inhalts, damit die Kopfzeile beim Tippen nicht wegrutscht.
 */
export function ScreenShell({
    children,
    gradient = true,
    className,
}: {
    children: React.ReactNode
    gradient?: boolean
    className?: string
}) {
    return (
        <div
            className={cn(
                'relative flex h-dvh w-full flex-col overflow-hidden text-wb-text',
                gradient
                    ? 'bg-[radial-gradient(ellipse_at_top,var(--color-wb-panel-hi),var(--color-wb-bg)_70%)]'
                    : 'bg-wb-bg',
                'px-5 pt-[max(0.75rem,env(safe-area-inset-top))]',
                'pb-[max(1rem,env(safe-area-inset-bottom))]',
                className,
            )}
        >
            {children}
        </div>
    )
}

interface TopBarProps {
    title: string
    right?: string
    onBack?: () => void
    onHelp?: () => void
}

export function TopBar({ title, right, onBack, onHelp }: TopBarProps) {
    const { t } = useTranslation()

    return (
        <header className="flex items-center justify-between gap-2.5 pt-1">
            <div className="flex w-[74px] gap-1.5">
                {onBack && (
                    <button
                        type="button"
                        onClick={onBack}
                        aria-label={t('common.back')}
                        className="flex size-8 flex-none items-center justify-center rounded-[10px] border border-wb-border bg-wb-panel-hi text-base font-bold"
                    >
                        ‹
                    </button>
                )}
                {onHelp && (
                    <button
                        type="button"
                        onClick={onHelp}
                        aria-label={t('common.help')}
                        className="flex size-8 flex-none items-center justify-center rounded-[10px] border border-wb-border bg-wb-panel-hi text-sm font-bold"
                    >
                        ?
                    </button>
                )}
            </div>

            <h2 className="text-center text-[13px] font-bold tracking-[.06em] text-wb-dim uppercase">
                {title}
            </h2>

            <div className="w-[74px] text-right wb-num text-[13px] font-bold text-wb-dim">
                {right ?? ''}
            </div>
        </header>
    )
}
